/**
 * SSO配置信息
 * 根据前端SSO集成开发文档和最新后端实现配置
 */

export const SSO_CONFIG = {
  // SSO服务器地址
  SSO_SERVER: process.env.REACT_APP_SSO_SERVER || 'https://sso.setonink.com/api',
  
  // SSO OAuth授权地址
  SSO_OAUTH_URL: process.env.REACT_APP_SSO_OAUTH_URL || 'https://sso.setonink.com/oauth',
  
  // 客户端ID (根据后端默认配置更新)
  CLIENT_ID: process.env.REACT_APP_SSO_CLIENT_ID || '4c4a21ab-9505-41c6-a59c-371eb585539c',
  
  // 回调地址
  CALLBACK_URL: process.env.REACT_APP_SSO_CALLBACK_URL || 'http://localhost:3000/auth/callback',
  
  // 后端API基础路径
  API_BASE: process.env.REACT_APP_API_BASE || 'https://ddos.data.setonink.com/api/sso',
  
  // 存储配置
  STORAGE_KEY: 'sso_token',
  USER_INFO_KEY: 'sso_user_info',
  
  // 登录URL端点
  LOGIN_URL_ENDPOINT: '/login-url',
  
  // 回调处理端点
  CALLBACK_ENDPOINT: '/callback',
  
  // 用户信息端点
  USER_INFO_ENDPOINT: '/user',
  
  // 注销端点
  LOGOUT_ENDPOINT: '/logout',
  
  // 受保护路由测试端点
  PROTECTED_ENDPOINT: '/protected',
  
  // 错误状态码
  ERROR_CODES: {
    KICKED_OUT: 'KICKED_OUT',
    SESSION_EXPIRED: 'SESSION_EXPIRED'
  }
};

export default SSO_CONFIG; 